import {CompleteCallback} from '@pixi/sound';

export interface IDuckMusicOptions {
    volume?: number;
    fadeDuration?: number;
}

export interface ISoundPlayer {
    play(soundID: string, loop?: boolean, onCompleteCallback?: any, stopIfPlaying?: boolean): void;

    stop(soundID: string): void;

    playMusic(musicID: string, complete?: CompleteCallback): void;

    stopMusic(): void;

    isMusicPlaying(): boolean;

    duckMusic(options?: IDuckMusicOptions): void;

    unduckMusic(): void;
}